import { List } from './List';
import { Root } from './Root';
import { Section } from './Section';
import { DefinitionList } from '../DefinitionList';
import { ListItem } from '../List';
export const Sidebar = {
    Root,
    Section,
    List,
    ListItem,
    DefinitionList: DefinitionList.Root,
    DefinitionItem: DefinitionList.Item,
    Definition: DefinitionList.Definition,
};
